/* eslint-disable react/no-array-index-key */
import React from 'react'
import { Col, Row } from 'antd'

import Box from 'components/Box/Box'
import Heading from 'components/Heading/Heading'
import Paragraph from 'components/Paragraph/Paragraph'
import PhoneVideo from 'components/PhoneVideo/PhoneVideo'
import Wrapper from 'components/Wrapper/Wrapper'

import styles from './LandingBoxSection.module.css'

function LandingBoxSection({ title, video, boxes }) {
  return (
    <div className={styles.landingBoxSection}>
      <Wrapper>
        <Row align="middle" gutter={24}>
          <Col xs={{ span: 24, order: 2 }} md={{ span: 14, order: 1 }}>
            <Heading level="h1">
              <h2 style={{ marginBottom: '30px' }}>{title}</h2>
            </Heading>
            <Row gutter={24}>
              {boxes.map((box, n) => (
                <Col
                  xs={24}
                  md={12}
                  style={{ marginBottom: 24 }}
                  key={`box_${n}`}
                >
                  <Box style={{ textAlign: 'center' }}>
                    {box.icon?.url && (
                      <div
                        style={{
                          maskImage: `url(${box.icon.url})`,
                          WebkitMaskImage: `url(${box.icon.url})`,
                        }}
                        className={styles.icon}
                      />
                    )}
                    <Heading level="h3">
                      <h2>{box.heading}</h2>
                    </Heading>
                    <Paragraph>{box.content}</Paragraph>
                  </Box>
                </Col>
              ))}
            </Row>
          </Col>
          <Col
            style={{ zIndex: 2 }}
            xs={{ span: 20, offset: 2, order: 1 }}
            md={{ span: 8, offset: 2, order: 2 }}
          >
            <PhoneVideo videoSrc={video} />
          </Col>
        </Row>
      </Wrapper>
    </div>
  )
}

export default LandingBoxSection
